import { Dialog, Button } from '@workspace/design-system/src/components';

interface PlanCancelUnavailableDialogProps {
  onClose: () => void;
}

export function PlanCancelUnavailableDialog({ onClose }: PlanCancelUnavailableDialogProps) {
  return (
    <Dialog>
      <Dialog.Content className="w-[520px] !top-[20vh] !translate-y-0">
        <Dialog.Header title="적용 후 7일이 경과하여 요금제를 취소할 수 없습니다" type="destructive" showIcon />

        <Dialog.Footer className="flex-row justify-end">
          <Button styleType="basic" styleSize="M-40" className="w-fit self-end" onClick={onClose}>
            확인
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
}
